import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('torqSttsStore', Object.keys(getters)),
	...mapState('torqSttsStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('torqSttsStore', Object.keys(actions)),
	...mapMutations('torqSttsStore', Object.keys(mutations))
};
